import { useContext, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { TextFieldForm } from "../../components/form/Input";
import { Button, CardMedia, Grid2, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RequestHelper } from "../../utils/requestHelper";
import { UserContext } from "../../contexts/UserContext";
import { _ACTIONS, _MESSAGES, _SWAL_ICONS } from "../../utils/constants";
import { getCookie, setCookie } from "../../utils/cookieHelper";
import { _ROUTER_DOM_URL, _ROUTES } from "../../utils/_routes_constants";
import { is } from "../../utils/function";
import Swal from "sweetalert2";

function Login() {
  let navigate = useNavigate();
  const requestHelper = new RequestHelper();
  const { user, setUser, setToken } = useContext(UserContext);
  const cookieToken = getCookie("token");

  useEffect(() => {
    if (is(user) && is(cookieToken))
      navigate(_ROUTER_DOM_URL.DASHBOARD_GENERAL);
  }, [user, cookieToken]);

  const onSubmit = (e) => {
    e.preventDefault();
    const email = e.target.elements.email.value;
    const password = e.target.password.value;
    requestHelper
      .doRequest(_ACTIONS.POST, `${_ROUTES.LOGIN}`, {
        email: email,
        password: password,
      })
      .then((response) => {
        if (response.data.config) {
          window.localStorage.setItem(
            "urlBack",
            JSON.stringify(response.data.config.urlBack)
          );
          window.localStorage.setItem(
            "listeAlertes",
            JSON.stringify(response.data.config.listeAlertes)
          );
        }
        if (response.data.user) {
          /** Update Context */
          setUser(response.data.user);
          setToken(response.data.token);
          /** Set Cookies */
          setCookie("token", response.data.token, 1);
          window.localStorage.setItem(
            "user",
            JSON.stringify(response.data.user)
          );
          /** Redirect */
          let redirect = _ROUTER_DOM_URL.DASHBOARD_GENERAL;

          if (window.localStorage.getItem("redirect")) {
            redirect = window.localStorage.getItem("redirect");
            window.localStorage.removeItem("redirect");
          }

          navigate(redirect);
        }
      });
  };

  const handleForgetPassword = () => {
    const { value: email } = Swal.fire({
      title: "Forgotten password",
      input: "email",
      showCancelButton: true,
      confirmButtonText: "Send",
      cancelButtonText: "Cancel",
      inputLabel: "Your mail address",
      inputPlaceholder: "mail@adress.com",
    }).then((r) => {
      if (r.isConfirmed) {
        Swal.fire(`Mail entered : ${r.value}`);
        requestHelper
          .post(_ROUTES.RESET_PASS, { email: r.value })
          .then((response) => {
            if (response.data.code === 200) {
              Swal.fire({
                title: "Email sent",
                text: _MESSAGES.emailsent,
                icon: _SWAL_ICONS.success,
                confirmButtonText: "Ok",
              });
            } else {
              Swal.fire({
                title: "Error",
                text: _MESSAGES.emailnotsent,
                icon: _SWAL_ICONS.error,
                confirmButtonText: "Ok",
              });
            }
          });
      }
    });
  };

  return (
    <>
      <Container component="main">
        <Box
          display={"flex"}
          sx={{
            height: "100vh",
          }}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}>
          <Grid2
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid2 size={8}></Grid2>
            <Grid2 size={4}>
              <CardMedia
                component="img"
                className="ubplogo"
                image={process.env.PUBLIC_URL + "/img/logo_ubp.png"}
                sx={{
                  borderRadius: "10px",
                }}
              />
            </Grid2>
            <Grid2
              size={8}
              sx={{
                height: "30vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <CardMedia
                component="img"
                sx={{
                  borderRadius: "10px",
                  height: "100%",
                  boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.25)",
                }}
                className="ubplogo"
                image={process.env.PUBLIC_URL + "/img/accueil.png"}
              />
            </Grid2>
            <Grid2 size={4} sx={{ height: "30vh" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  border: "1px solid black",
                  borderRadius: "10px",
                  boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.25)",
                  height: "100%",
                }}>
                <Box
                  component="form"
                  onSubmit={onSubmit}
                  noValidate
                  sx={{ padding: "30px" }}>
                  <TextFieldForm
                    required
                    fullWidth
                    id={"email"}
                    label={"Mail"}
                    placeholder={"email@adress.com"}
                    name={"username"}
                    autoComplete={"email"}
                    autoFocus
                  />
                  <TextFieldForm
                    required
                    fullWidth
                    name={"password"}
                    label={"Password"}
                    type={"password"}
                    id={"password"}
                    autoComplete={"current-password"}
                  />
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}>
                    <Link
                      style={{
                        cursor: "pointer",
                      }}>
                      <Typography
                        variant="body2"
                        onClick={handleForgetPassword}
                        sx={{
                          mt: 3,
                          display: "flex",
                          justifyContent: "end",
                        }}>
                        Forgot your Password ?
                      </Typography>
                    </Link>
                    <Button
                      type={"submit"}
                      color="grey"
                      variant={"contained"}
                      sx={{
                        mt: 3,
                      }}>
                      Login
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
          <Typography
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "center",
              fontSize: "9px",
              fontStyle: "italic",
            }}>
            V.{process.env.REACT_APP_VERSION} Toolapp 2025
          </Typography>
        </Box>
      </Container>
    </>
  );
}

export default Login;
